import {
    Component,
    EventEmitter,
    forwardRef,
    Input,
    Output,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Tag } from '@wdx/clmi/clmi-swagger-gen';
import { BaseReactiveFormAdapterClass } from '../../../../classes/base-reactive-form-adapter.class';
import { IWrappedFormComponent } from '@wdx/shared/infrastructure/form-framework';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'molecule-reactive-input-tags',
    templateUrl: './molecule-reactive-input-tags.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => MoleculeReactiveInputTagsComponent),
            multi: true,
        },
    ],
    standalone: false,
})
export class MoleculeReactiveInputTagsComponent
    extends BaseReactiveFormAdapterClass
    implements IWrappedFormComponent
{
    @Input() tags: Tag[];

    @Output() blurred = new EventEmitter();
}
